import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Poster } from "../../services/poster";

/**
 * Generated class for the CampaignPosterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "campaign-poster/:id",
})
@Component({
  selector: "page-campaign-poster",
  templateUrl: "campaign-poster.html",
})
export class CampaignPosterPage {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public poster: Poster
  ) {}

  ionViewDidLoad() {
    this.poster.show(this.navParams.data.id);
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign-poster/campaign-poster.ts